// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FAQCover {
    background-color: black;
    color: white;
    padding-top: 10px;
}

.FAQHeading {
    padding: 0;
    margin: 0;
    text-align: center;
}

.FAQHeading h1 {
    padding: 0;
    margin: 0;
}

.Virtue {
    box-sizing: border-box;
    position: relative;
    background-color: black;
    color: white;
    width: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
    column-gap: 15px;
    padding-top: 30px;
    padding-right: 15px;
    padding-left: 15px;
}

.Virtue:hover {
    cursor: pointer;
}

.Virtue .Virtues {
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.subHeading {
    display: flex;
    justify-content: space-between;
}

.PhylState,
.Consist,
.Creative {
    font-family: 'Josefin Sans', sans-serif;
    font-size: 15px;
    font-weight: 700;
    letter-spacing: 2px;
    border-bottom: 1px solid #DDDDDD;
    padding-top: 2px;
}

.PhylState .VText,
.Consist .VText,
.Creative .VText {
    max-height: 0px;
    min-height: 0;
    transition: max-height 0.5s ease-in-out;
    overflow: hidden;
    position: relative;
    font-family: 'Josefin Sans', sans-serif;
    font-size: 17px;
    font-weight: 300;
    letter-spacing: 1px;
    color: white;
}

.PhylState.Active .VText,
.Consist.Active .VText,
.Creative.Active .VText {
    max-height: 300px;
    min-height: 150px;
    transition: min-height 0.35s ease-in-out;
    overflow: hidden;
    position: relative;
}

.minusSign,
.plusSign {
    display: none;
}

.PhylState.Active .minusSign,
.Consist.Active .minusSign,
.Creative.Active .minusSign {
    display: contents;
}

.PhylState.Active .plusSign,
.Consist.Active .plusSign,
.Creative.Active .plusSign {
    display: none;
}

/* Media Query for Small Screens (Mobile) */
@media screen and (max-width: 768px) {
    .Virtue {
        grid-template-columns: 1fr;
    }
}


/* 


.FAQCover{
    background-color: black;
    color: white;
    
    padding-top: 10px;
   
}
.FAQHeading {
  padding: 0;
  margin: 0;
  text-align: center;
}
.FAQHeading h1{
  padding: 0;
  margin: 0;
}
.Virtue{
    box-sizing: border-box;
   

    position: relative;
   
    background-color: blac;
   
    color: white;
    width: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(420px, 1fr));
    column-gap: 15px;
    padding-top: 30px;
    padding-right: 15px;
    padding-left: 15px;
   
}  
.Virtue:hover{
   cursor: pointer;
   
}  
.Virtue .Virtues{
   
     display: flex;
     flex-direction: column;
     justify-content: center;
     
}

.subHeading{

    display: flex;
    justify-content: space-between;
}

.PhylState {
   
    
     font-family: 'Josefin Sans', sans-serif;
     font-size: 15px;
    font-weight: 700;
    letter-spacing: 2px;
    
    border-bottom: 1px solid #DDDDDD;
    padding-top: 2px;    
    transition: 1s ease-in-out;
   
 
}  
.PhylState:hover {
   
  
   border-bottom: 1px solid #DDDDDD;
}  
 
   

.PhylState .minusSign{
   
    display: none;
}

.VText{  


   
}


.PhylState .VText{  


    max-height: 0px;
    min-height: 0;
   
    transition: max-height 0.5s ease-in-out;
    overflow:hidden;
    position:relative;
    font-family: 'Josefin Sans', sans-serif;
    font-size: 17px;
    font-weight: 300;
    letter-spacing: 1px;
    
    color: white;
  
}




.PhylState.Active .VText{  
   
  

    max-height: 300px;
 
    min-height: 150px;

    transition: min-height 0.35s ease-in-out;
     overflow:hidden;
     position:relative;
     display: contents;


}



 
.PhylState.Active .minusSign{

    display: contents;
}  
.PhylState.Active .plusSign{

    display: none;
}  




.Consist{
   
    font-family: 'Josefin Sans', sans-serif;
    font-size: 15px;
    font-weight: 700;
    letter-spacing: 2px;
   
    border-bottom: 1px solid #DDDDDD;
    padding-top: 2px;
}

.Consist .VText{  

  
    max-height: 0px;
    min-height: 0;
  
    transition: max-height 0.5s ease-in-out;
    overflow:hidden;
    position:relative;
    font-family: 'Josefin Sans', sans-serif;
    font-size: 17px;
    font-weight: 300;
    letter-spacing: 1px;

    color: white;
   
   
   
}




.Consist .minusSign{
   display: none;
}


.Consist.Active .VText{  
   


    max-height: 300px;
 
    min-height: 150px;
   
    transition: min-height 0.35s ease-in-out;
     overflow:hidden;
     position:relative;
     display: contents;


}


.Consist.Active .minusSign{  
    display: contents;

}

.Consist.Active .plusSign{  
    display: none;

}


.Creative {

    font-family: 'Josefin Sans', sans-serif;
    font-size: 15px;
    font-weight: 700;
    letter-spacing: 2px;
 
    border-bottom: 1px solid #DDDDDD;
    padding-top: 2px;
}  


   
.Creative .minusSign{

   display: none;
   transition: 400ms ease-in-out;
}

.Creative .VText{  

    
    max-height: 0px;
    min-height: 0;
   
    transition: max-height 0.5s ease-in-out;
    overflow:hidden;
    position:relative;
    font-family: 'Josefin Sans', sans-serif;
    font-size: 17px;
    font-weight: 300;
    letter-spacing: 1px;
   
    color: white;
   
  
   
}




.Creative.Active .VText{  
   
  
    max-height: 300px;
 
    min-height: 150px;

    transition: min-height 0.35s ease-in-out;
     overflow:hidden;
     position:relative;
     display: contents;


}


.Creative.Active .minusSign{
    display: contents;

}

.Creative.Active .plusSign{
    display: none;
    transition: 400ms ease-in-out;

}

.vitueImage img{
    object-fit: cover;
    overflow: hidden;
    width: 100%;
    min-height: 320px;
    max-height: 320px;
   
} */`, "",{"version":3,"sources":["webpack://./src/Components/FAQs/FAQs.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,2DAA2D;IAC3D,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;;;IAGI,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;;;IAGI,eAAe;IACf,aAAa;IACb,uCAAuC;IACvC,gBAAgB;IAChB,kBAAkB;IAClB,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;;;IAGI,iBAAiB;IACjB,iBAAiB;IACjB,wCAAwC;IACxC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;;IAGI,iBAAiB;AACrB;;AAEA;;;IAGI,aAAa;AACjB;;AAEA,2CAA2C;AAC3C;IACI;QACI,0BAA0B;IAC9B;AACJ;;;AAGA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA4RG","sourcesContent":[".FAQCover {\n    background-color: black;\n    color: white;\n    padding-top: 10px;\n}\n\n.FAQHeading {\n    padding: 0;\n    margin: 0;\n    text-align: center;\n}\n\n.FAQHeading h1 {\n    padding: 0;\n    margin: 0;\n}\n\n.Virtue {\n    box-sizing: border-box;\n    position: relative;\n    background-color: black;\n    color: white;\n    width: 100%;\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n    column-gap: 15px;\n    padding-top: 30px;\n    padding-right: 15px;\n    padding-left: 15px;\n}\n\n.Virtue:hover {\n    cursor: pointer;\n}\n\n.Virtue .Virtues {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n.subHeading {\n    display: flex;\n    justify-content: space-between;\n}\n\n.PhylState,\n.Consist,\n.Creative {\n    font-family: 'Josefin Sans', sans-serif;\n    font-size: 15px;\n    font-weight: 700;\n    letter-spacing: 2px;\n    border-bottom: 1px solid #DDDDDD;\n    padding-top: 2px;\n}\n\n.PhylState .VText,\n.Consist .VText,\n.Creative .VText {\n    max-height: 0px;\n    min-height: 0;\n    transition: max-height 0.5s ease-in-out;\n    overflow: hidden;\n    position: relative;\n    font-family: 'Josefin Sans', sans-serif;\n    font-size: 17px;\n    font-weight: 300;\n    letter-spacing: 1px;\n    color: white;\n}\n\n.PhylState.Active .VText,\n.Consist.Active .VText,\n.Creative.Active .VText {\n    max-height: 300px;\n    min-height: 150px;\n    transition: min-height 0.35s ease-in-out;\n    overflow: hidden;\n    position: relative;\n}\n\n.minusSign,\n.plusSign {\n    display: none;\n}\n\n.PhylState.Active .minusSign,\n.Consist.Active .minusSign,\n.Creative.Active .minusSign {\n    display: contents;\n}\n\n.PhylState.Active .plusSign,\n.Consist.Active .plusSign,\n.Creative.Active .plusSign {\n    display: none;\n}\n\n/* Media Query for Small Screens (Mobile) */\n@media screen and (max-width: 768px) {\n    .Virtue {\n        grid-template-columns: 1fr;\n    }\n}\n\n\n/* \n\n\n.FAQCover{\n    background-color: black;\n    color: white;\n    \n    padding-top: 10px;\n   \n}\n.FAQHeading {\n  padding: 0;\n  margin: 0;\n  text-align: center;\n}\n.FAQHeading h1{\n  padding: 0;\n  margin: 0;\n}\n.Virtue{\n    box-sizing: border-box;\n   \n\n    position: relative;\n   \n    background-color: blac;\n   \n    color: white;\n    width: 100%;\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(420px, 1fr));\n    column-gap: 15px;\n    padding-top: 30px;\n    padding-right: 15px;\n    padding-left: 15px;\n   \n}  \n.Virtue:hover{\n   cursor: pointer;\n   \n}  \n.Virtue .Virtues{\n   \n     display: flex;\n     flex-direction: column;\n     justify-content: center;\n     \n}\n\n.subHeading{\n\n    display: flex;\n    justify-content: space-between;\n}\n\n.PhylState {\n   \n    \n     font-family: 'Josefin Sans', sans-serif;\n     font-size: 15px;\n    font-weight: 700;\n    letter-spacing: 2px;\n    \n    border-bottom: 1px solid #DDDDDD;\n    padding-top: 2px;    \n    transition: 1s ease-in-out;\n   \n \n}  \n.PhylState:hover {\n   \n  \n   border-bottom: 1px solid #DDDDDD;\n}  \n \n   \n\n.PhylState .minusSign{\n   \n    display: none;\n}\n\n.VText{  \n\n\n   \n}\n\n\n.PhylState .VText{  \n\n\n    max-height: 0px;\n    min-height: 0;\n   \n    transition: max-height 0.5s ease-in-out;\n    overflow:hidden;\n    position:relative;\n    font-family: 'Josefin Sans', sans-serif;\n    font-size: 17px;\n    font-weight: 300;\n    letter-spacing: 1px;\n    \n    color: white;\n  \n}\n\n\n\n\n.PhylState.Active .VText{  \n   \n  \n\n    max-height: 300px;\n \n    min-height: 150px;\n\n    transition: min-height 0.35s ease-in-out;\n     overflow:hidden;\n     position:relative;\n     display: contents;\n\n\n}\n\n\n\n \n.PhylState.Active .minusSign{\n\n    display: contents;\n}  \n.PhylState.Active .plusSign{\n\n    display: none;\n}  \n\n\n\n\n.Consist{\n   \n    font-family: 'Josefin Sans', sans-serif;\n    font-size: 15px;\n    font-weight: 700;\n    letter-spacing: 2px;\n   \n    border-bottom: 1px solid #DDDDDD;\n    padding-top: 2px;\n}\n\n.Consist .VText{  \n\n  \n    max-height: 0px;\n    min-height: 0;\n  \n    transition: max-height 0.5s ease-in-out;\n    overflow:hidden;\n    position:relative;\n    font-family: 'Josefin Sans', sans-serif;\n    font-size: 17px;\n    font-weight: 300;\n    letter-spacing: 1px;\n\n    color: white;\n   \n   \n   \n}\n\n\n\n\n.Consist .minusSign{\n   display: none;\n}\n\n\n.Consist.Active .VText{  \n   \n\n\n    max-height: 300px;\n \n    min-height: 150px;\n   \n    transition: min-height 0.35s ease-in-out;\n     overflow:hidden;\n     position:relative;\n     display: contents;\n\n\n}\n\n\n.Consist.Active .minusSign{  \n    display: contents;\n\n}\n\n.Consist.Active .plusSign{  \n    display: none;\n\n}\n\n\n.Creative {\n\n    font-family: 'Josefin Sans', sans-serif;\n    font-size: 15px;\n    font-weight: 700;\n    letter-spacing: 2px;\n \n    border-bottom: 1px solid #DDDDDD;\n    padding-top: 2px;\n}  \n\n\n   \n.Creative .minusSign{\n\n   display: none;\n   transition: 400ms ease-in-out;\n}\n\n.Creative .VText{  \n\n    \n    max-height: 0px;\n    min-height: 0;\n   \n    transition: max-height 0.5s ease-in-out;\n    overflow:hidden;\n    position:relative;\n    font-family: 'Josefin Sans', sans-serif;\n    font-size: 17px;\n    font-weight: 300;\n    letter-spacing: 1px;\n   \n    color: white;\n   \n  \n   \n}\n\n\n\n\n.Creative.Active .VText{  \n   \n  \n    max-height: 300px;\n \n    min-height: 150px;\n\n    transition: min-height 0.35s ease-in-out;\n     overflow:hidden;\n     position:relative;\n     display: contents;\n\n\n}\n\n\n.Creative.Active .minusSign{\n    display: contents;\n\n}\n\n.Creative.Active .plusSign{\n    display: none;\n    transition: 400ms ease-in-out;\n\n}\n\n.vitueImage img{\n    object-fit: cover;\n    overflow: hidden;\n    width: 100%;\n    min-height: 320px;\n    max-height: 320px;\n   \n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
